<template>
    <div class="mt-2" v-if="curRecord.TestID>0 " style="font-size:90%;">
      <div class="container-fluid">
        <h5 class="text-white bg-success py-2 mb-1">
          <u><b>{{ curRecord.TestName }}</b></u>
        </h5>ประกอบด้วยเทสดังนี้
      </div>
      <table id="tableDtl" class="table table-hover display table-sm">
          <thead class="text-white" style="background:Navy">
          <tr>
              <th class="text-start">รหัส</th>
              <th class="text-start">เทส<span class="badge border text-white float-end me-2">ห้องตรวจ</span></th>
              <th>คำสั่ง</th>
          </tr>
          </thead>
          <tbody>
              <tr v-for="(item, index) in dataDtllists" :key="item.ItemTestID"
              :data-id="item.ItemTestID" :data-testid="item.TestID" :data-testdtlid="item.TestDtlID"
              @click="tableChanged($event, item)">
              <!-- @click="getSelectedRow($event, item)"> -->
                  <td class="text-start">{{index+1}}. {{ item.ItemTestCode }}</td>
                  <td class="text-start" v-if="item.PrintUL==0">
                    &nbsp; {{ item.ItemTestName }}
                    <span class="badge border text-success float-end me-2">{{item.RoomName}}</span>
                  </td>
                  <td class="text-start" v-else> <b>{{ item.ItemTestName }} </b> </td>
                  <td>
                      <button type="button" class="btn btn-warning btn-sm me-1 py-0" id="Edit"  title="ปรับคุณสมบัติ" data-bs-toggle="modal" data-bs-target="#itemPropModal"><i class="fa fa-gear"></i></button>
                      <button class="btn btn-danger btn-sm py-0" id="Delete"
                        :hidden="curRecord.FromItemTest==1"
                        @click="delRecord(item)">Del</button>
                  </td>
              </tr>
          </tbody>
      </table>
      <br>
      <p :hidden="curRecord.FromItemTest != 1" style="font-size:80%;"> <i> Note : ชุดตรวจเดี่ยวที่โคลนมาจากเทสตรวจ ไม่อนุญาติให้เพิ่มเทสหรือลบเทสตรวจออกจากชุดตรวจ </i></p>

      <div class="container" :hidden="curRecord.FromItemTest == 1">
        <div class="btn-group" role="group" aria-label="Basic outlined example">
          <button type="button" class="btn btn-outline-primary" title="ย้ายตำแหน่งขึ้น" @click="upNdown('up');">Up</button>
          <button type="button" class="btn btn-outline-primary" title="ย้ายตำแหน่งลง" @click="upNdown('down');">Down</button>
        </div>
        <button type="button" class="btn btn-primary ms-2" title="จัดเก็บลำดับที่เปลี่ยนแปลง" @click="applySeqItems();">บันทึกลำดับที่จัดเรียง</button>
      </div>
    </div>

    <!-- ================================================================ -->
    <!-- Modal Form -->
    <div id="itemPropModal" class="modal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header" style="background-color:Gainsboro">
            <h5 class="modal-title">ปรับคุณสมบัติรายการเทส</h5> {{curRecord.TestID}}
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-start">
            <h3 class="text-primary">{{ItemTestName}}</h3>
            <hr>
            <form id="fmItemProp" @submit.prevent="" >
                <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                <input type="text" hidden class="form-control" id="TestID" placeholder="" name="TestID" v-model="TestID">
                <input type="text" hidden class="form-control" id="ItemTestID" placeholder="" name="ItemTestID" v-model="ItemTestID">
                <input type="text" hidden class="form-control" id="UserID" placeholder="" name="UserID" v-model="globalUserID" >
                <div class="row mb-2" title="เทสที่กำหนดค่านี้เป็นหัวข้อย่อยจะแสดงเป็นตัวเข้มและไม่สามารถป้อนค่าได้">
                    <div class="input-group input-group-sm mb-1">
                      <div class="input-group-prepend">
                        <span class="input-group-text fs-5" style="width:180px;">กำหนดเทสตรวจเป็น :</span>
                      </div>
                      <select class="form-select text-primary fs-5" ref="PrintUL" name="PrintUL" v-model="PrintUL">
                        <option class="text-dark" style="background-color:white;" value="0">เทสตรวจ (ค่าปกติ)</option>
                        <option class="text-secondary" style="background-color:white;" value="1">เป็นหัวข้อย่อย</option>
                      </select>
                    </div>
                    <p class="text-danger ms-2" style="font-size: 90%">*เทสที่กำหนดค่านี้เป็น "หัวข้อย่อย" จะแสดงเป็นตัวเข้มและไม่สามารถป้อนค่าได้</p>
                </div>
                <br>
                <div class="row mb-2">
                    <div class="input-group input-group-sm mb-1">
                      <div class="input-group-prepend">
                      <span class="input-group-text" style="width:140px;">สีตัวอักษร :</span>
                      </div>
                      <select class="form-select" ref="FontColor" name="FontColor" v-model="FontColor"
                        style="background-color:PapayaWhip;"
                        title="กำหนดสีของตัวอักษรของเทส">
                        <option class="text-dark" style="background-color:white;" value="black">Black (สีดำ)</option>
                        <option class="text-secondary" style="background-color:white;" value="white">White (สีขาว)</option>
                        <option class="bg-white" style="color:#0000FF;" value="#0000FF">Blue (น้ำเงิน)</option>
                        <option class="bg-white" style="color:#00FFFF;" value="#00FFFF">Aqua (ฟ้าน้ำทะเล)</option>
                        <option class="bg-white" style="color:#32CD32;" value="#32CD32">LimeGreen (เขียวสด)</option>
                        <option class="bg-white" style="color:#808080;" value="#808080">Gray (เทา)</option>
                        <option class="bg-white" style="color:#9400D3;" value="#9400D3">DarkViolet (ม่วง)</option>
                        <option class="bg-white" style="color:#FFFFE0;" value="#FFFFE0">LightYellow (ครีม)</option>
                        <option class="bg-white" style="color:#FFFF00;" value="#FFFF00">Yellow (เหลือง)</option>
                        <option class="bg-white" style="color:#FFC0CB;" value="#FFC0CB">Pink (ชมพู)</option>
                        <option class="bg-white" style="color:#FF0000;" value="#FF0000">Red (แดง)</option>
                      </select>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="input-group input-group-sm mb-1">
                      <div class="input-group-prepend">
                      <span class="input-group-text" style="width:140px;">สีพื้นหลัง :</span>
                      </div>
                      <select class="form-select" ref="BgColor" name="BgColor" v-model="BgColor"
                        title="กำหนดสีพื้นหลังของเทส">
                        <option class="text-white" style="background-color:black;" value="black">Black (สีดำ)</option>
                        <option class="bg-white" value="white">White (สีขาว)</option>
                        <option class="text-white" style="background-color:#0000FF;" value="#0000FF">Blue (น้ำเงิน)</option>
                        <option class="text-dark" style="background-color:#00FFFF;" value="#00FFFF">Aqua (ฟ้าน้ำทะเล)</option>
                        <option class="text-dark" style="background-color:#32CD32;" value="#32CD32">LimeGreen (เขียวสด)</option>
                        <option class="text-dark" style="background-color:#808080;" value="#808080">Gray (เทา)</option>
                        <option class="text-white" style="background-color:#9400D3;" value="#9400D3">DarkViolet (ม่วง)</option>
                        <option class="text-dark" style="background-color:#FFFFE0;" value="#FFFFE0">LightYellow (ครีม)</option>
                        <option class="text-dark" style="background-color:#FFFF00;" value="#FFFF00">Yellow (เหลือง)</option>
                        <option class="text-dark" style="background-color:#FFC0CB;" value="#FFC0CB">Pink (ชมพู)</option>
                        <option class="text-white" style="background-color:#FF0000;" value="#FF0000">Red (แดง)</option>
                      </select>
                    </div>
                </div>
            </form>
          </div>

          <div class="modal-footer" style="background-color:Gainsboro">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="updateDtlSuitProperties()">Save changes</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'TestsuitDtl',
  components: {

  },
  data () {
    return {
      dataDtllists: [],
      // ================== record : ข้อมูล item ปัจจุบันที่คลิกเลือก =================== //
      TestID: 0,
      ItemTestID: 0,
      ItemTestName: '',
      // กำหนดเทสเป็น "หัวข้อย่อย" สำหรับใช้จัดกลุ่มย่อยในุดตรวจ
      PrintUL: 0,
      // สีที่กำหนดให้กับเทส
      FontColor: 'black',
      BgColor: 'white'
      // =============================================================== //
    }
  },
  mounted () {
    this.getData()
  },
  props: ['curRecord'],
  methods: {
    // Save สมบัติของเทส : PrintUL, FontColor, BgColor
    updateDtlSuitProperties () {
      var self = this
      // แปลงข้อมูลจากฟอร์ม
      var x = $('#fmItemProp').serializeArray()
      var formData = {}
      $.each(x, function (i, field) {
        $.extend(formData, { [field.name]: field.value })
      })
      // console.log(formData)
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/upd_dtl_testsuit_properties.php',
        data: { request: JSON.stringify(formData) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1000
          }).then(function (result) {
            // รีเฟรชตารางด้านขวา รายการของชุดตรวจ โดยการเปลี่ยนค่าคีย์ เพื่อ ReRender Component
            self.refreshDtlAfterUpdate()
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    },
    tableChanged (event, row) {
      var curRow = Object.assign({}, row)
      this.TestID = this.curRecord.TestID
      this.ItemTestID = curRow.ItemTestID
      this.ItemTestName = curRow.ItemTestName
      this.PrintUL = curRow.PrintUL
      this.FontColor = curRow.FontColor
      this.BgColor = curRow.BgColor
      // แถบสี row ที่คลิก
      this.getSelectedRow(event, row)
    },
    // จัดเก็บคุณสมบัติของเทส เช่น PrintUL, สี, สีพื้น
    applyPropItem () {
      this.refreshDtlAfterUpdate()
    },
    refreshDtlAfterUpdate () {
      this.$emit('onRefreshDtlAfterUpdate')
    },
    // จัดเก็บลำดับที่จัดเรียงใหม่
    applySeqItems () {
      var self = this
      var arrDtl = []
      // แปลงข้อมูลจากฟอร์ม
      var table = document.getElementById('tableDtl')
      for (var i = 1; i < table.rows.length; i++) {
        // console.log(table.rows[i].getAttribute('data-id'))
        arrDtl.push({
          TestDtlID: table.rows[i].getAttribute('data-testdtlid'),
          TestID: table.rows[i].getAttribute('data-testid'),
          ItemTestID: table.rows[i].getAttribute('data-id'),
          Seq: i,
          UserID: this.globalUserID
        })
      }
      // console.log(arrDtl)
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/update_testsuit_seqitems.php',
        data: { requestDtl: JSON.stringify(arrDtl) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกลำดับใหม่เสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            self.refreshDtlAfterUpdate()
          })
        })
        .fail(function (resp) {
          console.log(resp)
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    },
    upNdown (direction) {
      var rows = document.getElementById('tableDtl').rows
      var parent = rows[this.index].parentNode
      if (direction === 'up') {
        if (this.index > 1) {
          parent.insertBefore(rows[this.index], rows[this.index - 1])
          // when the row go up the index will be equal to index - 1
          this.index = this.index - 1
        }
      }
      if (direction === 'down') {
        if (this.index < rows.length - 1) {
          parent.insertBefore(rows[this.index + 1], rows[this.index])
          // when the row go down the index will be equal to index + 1
          this.index = this.index + 1
        }
      }
    },
    // แสดงแถบสีว่า เลือก row นี้
    getSelectedRow (event, row) {
      // console.log('row Index :')
      // console.log(event.target.parentNode.rowIndex)
      this.index = event.target.parentNode.rowIndex
      var table = document.getElementById('tableDtl')
      for (var i = 1; i < table.rows.length; i++) {
        table.rows[i].style.backgroundColor = 'white'
        table.rows[i].style.color = 'black'
      }
      table.rows[this.index].style.backgroundColor = 'MediumBlue'
      table.rows[this.index].style.color = 'white'

      // ---------- ค่า item ปัจจุบันสำหรับแสดงเพื่อปรับ PrintUL, FontColor, BgColor ----------- //
      this.tableChanged(row)
    },
    delRecord (item) {
      var self = this
      Swal.fire({
        title: item.TestName,
        text: 'คุณแน่ใจหรือไม่...ที่จะลบข้อมูล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/del_dtl_testsuit.php',
            // url: 'http://localhost/vmedlab/src/service/setdata/del_dtl_testsuit.php',
            // url: 'http://www.labsmartsoft.com/vmedlab/service/' + 'setdata/del_dtl_testsuit.php',
            data: { id: item.TestDtlID }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกลบเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              // รีเฟรชตารางด้านขวา รายการของชุดตรวจ โดยการเปลี่ยนค่าคีย์ เพื่อ ReRender Component
              self.refreshDtlAfterUpdate()
            })
          })
        }
      })
    },
    getData () {
      // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
    //   MyApiClient.get('getdata/testsuits_dtl_like.php')
      MyApiClient.get('getdata/testsuits_dtl_like.php?key=' + this.curRecord.TestID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataDtllists = resp.data.response
          // setTimeout(function () { $('#myTSTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
